import React from "react";
import { Container, Title, Button } from "@bsf/force-ui";
import { ExternalLink, Plus } from "lucide-react";
import { __ } from "@wordpress/i18n";
import apiFetch from "@wordpress/api-fetch";

const WelcomeContainer = () => {
	return (
		<div>
			<Container
				align="center"
				className="bg-background-primary border-[0.5px] border-subtle rounded-xl shadow-sm mb-6 p-6 flex flex-col lg:flex-row"
				containerType="flex"
				direction="row"
				justify="between"
				gap="sm"
			>
				<Container.Item shrink={1}>
					<Title
						description=""
						icon={null}
						iconPosition="right"
						className=""
						size="lg"
						tag="h3"
						title={__("Welcome to Ultimate Addons for WPBakery Page Builder!", "ultimate_vc")}
					/>
					<p className="text-sm font-medium text-text-tertiary m-0" style={{ marginTop: '1.5rem', maxWidth: '34rem' }}>
						{__(
							"You are about to begin with the most powerful addon for WPBakery Page Builder that add in many advanced features developed with love at Brainstorm Force.",
							"ultimate_vc"
						)}
					</p>
					<div className="flex items-center gap-2" style={{ paddingTop: '1.5rem' }}>
						<Button
							icon={<Plus />}
							iconPosition="right"
							variant="primary"
							className="bg-[#0017E1] uavc-remove-ring"
							style={{
								borderColor: "#F5F8FF",
								backgroundColor: "#0017E1",
							}}
							onMouseEnter={(e) =>
							(e.currentTarget.style.color =
								"#fff")
							}
							onMouseLeave={(e) =>
								(e.currentTarget.style.color =
									"#F5F8FF") &&
								(e.currentTarget.style.borderColor =
									"#F5F8FF")
							}
                                                        onClick={() => {
                                                                apiFetch( {
                                                                        path: '/ultimate-vc/v1/create-page',
                                                                        method: 'POST',
                                                                } ).then( ( res ) => {
                                                                        if ( res.url ) {
                                                                                window.open( res.url, '_blank' );
                                                                        }
                                                                } );
                                                        }}
						>
							{__("Create New Page", "ultimate_vc")}
						</Button>
					</div>
				</Container.Item>
				<Container.Item className="md:mt-0 uavc-hide-scrollbar mt-4">
					<iframe
						width="280"
						loading="lazy"
						height="160"
						src="https://www.youtube.com/embed/fmCZS89LyYk"
						frameBorder="0"
						style={{ borderRadius: "8px" }}
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					/>

				</Container.Item>
			</Container>
		</div>
	);
};
export default WelcomeContainer;
